import ITranch from '@/creditflowresearch/domain/vo/Tranch/ITranch';
import CopyToClipboardButton from '@framework/ui/Atoms/Button/CopyToClipboardButton';
import IconCheck from '@creditflowresearch/uilib/Icon/IconCheck';

import styles from '@/creditflowresearch/ui/components/deals/DealListTable/components/TrancheList/components/Header/header.module.scss';

export const Header = ({ tranche, index }: { tranche: ITranch, index: number }) => (
  <div className={ styles.container }>
    <div className={ styles.headerTitle }>
      <div className={ styles.titleRow }>
        <strong className={ styles.trancheNumber }>Tranche #{ index + 1 }</strong>
        <span className={ styles.issuers }>{ tranche.issuers.map((issuer) => issuer.name).join(', ') }</span>
      </div>
    </div>
    <div className={ styles.status }>
      { tranche.droppedTranche ? <div className={ styles.statusText }>Dropped</div> : (
        tranche.figis?.[0] && (
          <div className={ styles.copyButtonWrapper }>
            <CopyToClipboardButton
              labelAfterCopy="FIGI copied"
              labelBeforeCopy={ tranche.figis[0] }
              className={ styles.copyButton }
              copiedIcon={ IconCheck }
              content={ tranche.figis[0] }
              dataTest="copyFIGIButton"
            />
          </div>
        )
      ) }
    </div>
  </div>
);
